const webUrl = process.env.REACT_APP_WEB_URL;
const serverUrl = process.env.REACT_APP_SERVER_URL;
const contactUrl = process.env.REACT_APP_CONTACT_URL;

const mapboxToken = process.env.REACT_APP_MAPBOX_TOKEN || '';
const baseMapUrl = 'https://api.mapbox.com/styles/v1';
const satelliteStreetsBaseMap = `${baseMapUrl}/mapbox/satellite-streets-v9/tiles/256/{z}/{x}/{y}?&access_token=${mapboxToken}`;

const smacoreLink = 'https://portal.sma.gob.cl/index.php/2022/04/05/sma-dicta-instruccion-para-reporte-estandarizado-de-componente-de-biodiversidad/';

const maxSizeFileUpload = parseInt(process.env.REACT_APP_MAX_SIZE_FILE_UPLOAD, 10);
const maxKmlPoints = parseInt(process.env.REACT_APP_MAX_KML_POINTS, 10);
const maxKmlLines = parseInt(process.env.REACT_APP_MAX_KML_LINES, 10);
const maxKmlPolygons = parseInt(process.env.REACT_APP_MAX_KML_POLYGONS, 10);

const maintenanceDates = {
  start: process.env.REACT_APP_MAINTENANCE_START,
  finish: process.env.REACT_APP_MAINTENANCE_FINISH,
};

const captureUrl = process.env.REACT_APP_CAPTURE_URL;

const titilerBaseUrl = process.env.REACT_APP_TITILER_BASE_URL;
const tiffsAssetsBaseUrl = process.env.REACT_APP_TIFFS_ASSETS_BASE_URL;


export default {
  webUrl,
  serverUrl,
  contactUrl,
  satelliteStreetsBaseMap,
  maxSizeFileUpload,
  maxKmlPoints,
  maxKmlLines,
  maxKmlPolygons,
  maintenanceDates,
  smacoreLink,
  captureUrl,
  titilerBaseUrl,
  tiffsAssetsBaseUrl,
};
